import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { post } from "@common/services/request";

const Impersonate = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const impersonationCode = searchParams.get("impersonation_code");

    if (!impersonationCode) {
      window.location.href = "/";
      return;
    }

    // Clear any stale tokens so post() skips the token-refresh path
    localStorage.removeItem("token");
    localStorage.removeItem("exp");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("exp");
    sessionStorage.removeItem("is_impersonating");

    post("v1/impersonate/exchange/", { code: impersonationCode })
      .then((response) => {
        if (response && response.token) {
          sessionStorage.setItem("token", response.token);
          if (response.exp) {
            sessionStorage.setItem("exp", response.exp * 1000);
          }
          sessionStorage.setItem("is_impersonating", "true");
          // Force a full page reload so that all states (redux, router) re-initialize
          // with the new token seamlessly.
          window.location.href = "/";
        } else {
          console.error("Invalid response from exchange:", response);
          window.location.href = "/";
        }
      })
      .catch((err) => {
        console.error("Error exchanging impersonation code", err);
        window.location.href = "/";
      });
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h2>Impersonating user...</h2>
    </div>
  );
};

export default Impersonate;
